<template>
  <div>
    <md-content class="right-list md-elevation-12" v-if="true">
    <md-toolbar md-elevation="0">
        <span class="md-title">{{ city.location }}</span>
        <div @click="$emit('close')" class="right-detail-close"><md-icon>close</md-icon></div>
    </md-toolbar>
    <md-list class="md-double-line">
      <md-list-item @click="select(item)" v-for="item in city.items" :key="item.id">
        <md-icon class="md-icon">radio_button_unchecked</md-icon>
        <div class="md-list-item-text">
          <span>{{ item.Name }}</span>
          <span>{{ item['Medium 1'] }}<span v-if="item['Medium 2'] !== ''">, {{ item['Medium 2'] }}</span>
          </span>
        </div>
      </md-list-item>
    </md-list>
  </md-content>
  </div>
</template>

<script>
export default {
  props: {
    city: Object
  },
  methods: {
    select (item) {
      this.$emit('artistSelected', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 900px) {
  .right-list {
    position: absolute;
    z-index: 1;
    right: 0px;
    width: 400px;
    height: 100%;
    overflow: auto;
  }
}
@media (min-width: 600px) {
  .right-list {
    position: absolute;
    z-index: 1;
    right: 0px;
    width: 300px;
    height: 100%;
    overflow: auto;
  }
}

@media (max-width: 600px) {
  .right-list {
    position: absolute;
    z-index: 1;
    right: 0px;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}
.md-card {
  margin: 40px;
  display: inline-block;
  vertical-align: top;
}
.right-detail-close {
  font-size:24px;
  margin-left:auto;
  margin-right:0;
}
.right-detail-close span:hover {
  cursor: pointer;
}
</style>
